import type { SVGProps } from 'react';

interface ArrowRightIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const ArrowRightIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & ArrowRightIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 16 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M5.313 13.02a.5.5 0 0 1-.048-.65l.048-.057L9.626 8 5.313 3.687a.5.5 0 0 1-.048-.651l.048-.056a.5.5 0 0 1 .651-.049l.056.049 4.667 4.667a.5.5 0 0 1 .048.65l-.048.057L6.02 13.02a.5.5 0 0 1-.707 0"
      fill="#B0CEFC"
    />
  </svg>
);
